import { render, staticRenderFns } from "./FaqLayout.vue?vue&type=template&id=d41f628c&scoped=true&"
import script from "./FaqLayout.vue?vue&type=script&lang=js&"
export * from "./FaqLayout.vue?vue&type=script&lang=js&"
import style0 from "./FaqLayout.vue?vue&type=style&index=0&id=d41f628c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41f628c",
  null
  
)

export default component.exports